import { render, staticRenderFns } from "./Product.yaml?vue&type=template&id=ac01c18a&component"
import script from "./Product.yaml?vue&type=script&lang=ts&component"
export * from "./Product.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports